var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useEffect, useMemo, useState } from 'react';
import { useAtomValue } from 'jotai';

import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { templatesAtom } from "../../../atoms";
import { useLoaderData } from 'react-router';


import { formatParagraphData } from "./utils/formatters";
import { getLanguageName } from "./utils/getLanguageName";
import { ParagraphsTable } from "./components/paragraphs/Table";
import { ViewParagraphSidePanel } from "./components/paragraphs/ViewParagraphSidePanel";

const PXParagraphDashboard = () => {var _paragraphInfo$templa;
  const {
    paragraphs = [],
    extractorId,
    languages = [],
    settings
  } = useLoaderData();







  const [sidePanel, setSidePanel] = useState(false);
  const [paragraphOnView, setParagraphOnView] = useState(undefined);
  const [paragraphInfo, setParagraphInfo] = useState(undefined);
  const [entityLanguages, setEntityLanguages] = useState([]);
  const templates = useAtomValue(templatesAtom);

  const pxParagraphData = useMemo(
    () => formatParagraphData(paragraphs, templates, settings),
    [paragraphs, templates, settings]
  );

  const [filters, setFilters] = useState([]);

  useEffect(() => {
    if (pxParagraphData.length > 0) {
      const [pxParagraphDatum] = pxParagraphData;
      setParagraphInfo(pxParagraphDatum);

      const availableLanguages = [
      ...pxParagraphDatum.languages.map((lang) => getLanguageName(languages, lang)),
      ...pxParagraphData.
      filter((datum) => datum.paragraphCount === pxParagraphDatum.paragraphCount).
      reduce((subRowLanguages, curr) => {
        if (curr.subRows) {
          curr.subRows.forEach((subRow) => {
            subRow.languages.forEach((lang) => {
              const languageName = getLanguageName(languages, lang);
              subRowLanguages.push(languageName);
            });
          });
        }
        return subRowLanguages;
      }, [])];

      setEntityLanguages(availableLanguages);
      setFilters([
      {
        label: 'Languages',
        key: 'languages',
        options: availableLanguages.map((lang) => ({
          key: lang,
          label: getLanguageName(languages, lang),
          count: 1
        }))
      }]
      );
    }
  }, [pxParagraphData, languages]);

  const openSidePanel = (id) => {
    setSidePanel(true);
    const targetParagraph = pxParagraphData.find((paragraph) => paragraph._id === id);
    if (targetParagraph) {
      setParagraphOnView(_objectSpread(_objectSpread({},
      targetParagraph), {}, {
        languages: [getLanguageName(languages, targetParagraph.languages[0])] })
      );
    }
  };

  return (/*#__PURE__*/
    _jsx("div", {
      className: "tw-content",
      "data-testid": "settings-paragraph-extractor",
      style: { width: '100%', overflowY: 'auto' } }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, {
      title: (paragraphInfo === null || paragraphInfo === void 0 ? void 0 : paragraphInfo.title) || '',
      path:
      new Map([
      ['Paragraph extraction', '/settings/paragraph-extraction'],
      [
      (paragraphInfo === null || paragraphInfo === void 0 ? void 0 : (_paragraphInfo$templa = paragraphInfo.template) === null || _paragraphInfo$templa === void 0 ? void 0 : _paragraphInfo$templa.name) || '',
      `/settings/paragraph-extraction/${extractorId}/entities`]]

      ) }

    ), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0,
    paragraphInfo && /*#__PURE__*/
    _jsx(ParagraphsTable, {
      pxParagraphData: pxParagraphData,
      paragraphInfo: paragraphInfo,
      entityLanguages: entityLanguages,
      filters: filters,
      viewParagraph: openSidePanel }
    )

    )
    ), /*#__PURE__*/
    _jsx(ViewParagraphSidePanel, {
      isSidePanelOpen: sidePanel,
      setIsSidePanelOpen: setSidePanel,
      paragraphOnView: paragraphOnView }
    )
    ));

};

export { PXParagraphDashboard };